export default __webpack_public_path__ + "static/media/m_doctor.f3d0578d.png";